import React, { Component } from 'react'
import { Row, Col, Icon, Tooltip, Select, Input, Spin } from 'antd'
import { compose, graphql, withApollo, Query } from 'react-apollo'
import gql from 'graphql-tag'
// import PropTypes from 'prop-types'
import moment from 'moment'

import { FormattedMessage } from 'react-intl'
import Profile from './Components/Profile'
import RegistrationItem from './Components/RegistrationItem'
import './styles.css'
import { DashBoardBox } from '~/styles'
import registrationsQuery from '~/App/graphql/queries/registrations.gql'
import { inject, observer } from 'mobx-react'

const Option = Select.Option
const InputGroup = Input.Group
class DashboardPage extends Component {
  state = {
    sort: `_ID_DESC`,
    status: ``
  }

  handleSubmit = ({ registrationId }) => {
    this.props
      .submitRegistration({
        variables: { _id: registrationId }
      })
  }
  handleSortChange = (value) => {
    this.setState({
      sort: value
    })
  }
  handleStatusChange = (value) => {
    this.setState({
      status: value
    })
  }
  render () {
    const { client, i18n: { locale } } = this.props
    const data = client.readQuery({
      query: gql`
        {
          currentUser {
            _id
            email
            profile {
              firstName
              lastName
            }
            achievements {
              _id
              reward {
                _id
                name {
                  en
                  th
                }
                type
                badge {
                  completed
                }
              }
              createdAt
            }
          }
        }
      `
    })
    const { profile, achievements = [] } = data.currentUser
    let { sort, status } = this.state
    const _operators = {
      status: {
        in: [``, 'all'].includes(status) ? [`paid`, `draft`, `submitted`, `payment_verifying`, `accepted`, `rejected`] : status
      }
    }

    const filter = {_operators}
    return (
      <DashBoardBox>
        <div className="contentWrapper">
          <Row>
            <Col className="sortAndfilter">
              <InputGroup compact>
                <Select defaultValue={`_ID_DESC`} style={{ width: 120 }} onChange={this.handleSortChange}>
                  <Option value={`_ID_DESC`}>{{ th: 'สมัครล่าสุด', zh: 'recent', en: 'recent' }[locale]}</Option>
                  <Option value={`_ID_ASC`}>{{ th: 'สมัครก่อน', zh: 'least recent', en: 'least recent' }[locale]}</Option>
                </Select>
                <Select defaultValue={``} style={{ width: 168 }} onChange={this.handleStatusChange}>
                  <Option value={``}>{{ th: 'สถานะการสมัคร', en: 'status', zh: 'status' }[locale]}</Option>
                  <Option value={`paid`}>{{ th: 'ชำระเงินเรียบร้อย', en: 'paid', zh: 'paid' }[locale]}</Option>
                  <Option value={`all`}>{{ th: 'สถานะทั้งหมด', en: 'all', zh: 'all' }[locale]}</Option>
                  {/* <Option value={`draft`}>กรอกข้อมูลไม่สมบูรณ์</Option> */}
                  <Option value={`submitted`}>{{ th: 'ยังไม่ได้ชำระเงิน', en: 'pending payment', zh: 'pending payment' }[locale]}</Option>
                </Select>
              </InputGroup>
            </Col>
          </Row>
          <Query query={registrationsQuery}
            variables={{ sort, filter }}
            fetchPolicy='cache-and-network' >
            {({ data, loading }) => {
              if (loading) {
                return <div className="modLoadding">
                  <Spin tip="Loading..." size="large" />
                </div>
              }
              if (!data || !data.registrations) {
                return <div>No Registrations</div>
              }
              let registrations = data.registrations
              if (status === ``) {
                registrations = registrations.filter(r => {
                  const isExpired = !['paid', 'payment_verifying'].includes(r.status) && r.expireAt && r.expired
                  return !isExpired
                })
              }
              return <Row>
                <Col xs={24} md={8}>
                  <Profile profile={profile} registrations={registrations} />
                  <div className="badgesBox">
                    <p style={{ fontSize: '16px', borderBottom: '1px solid gainsboro', paddingBottom: '10px' }}>
                      <FormattedMessage id="app.badges" defaultMessag="E-BADGES" />&nbsp;
                      <Tooltip placement="top" title={`ได้รับสัญลักษณ์ E-BADGES จากการส่งผลการวิ่งในกิจกรรมพิเศษ`}>
                        <Icon type="info-circle-o" />
                      </Tooltip>
                    </p>
                    { achievements.map(({ reward, createdAt }) => (
                      <Tooltip key={reward._id} placement="top" title={reward.name.en}>
                        <img key={reward._id} className="badge"
                          src={reward.badge.completed}
                          alt={`${reward.name.en}, ${moment(createdAt).format('DD MMM YYYY HH:mm')}`}/>
                      </Tooltip>
                    ))}
                  </div>
                </Col>
                {registrations &&
                  <Col xs={24} md={16}>
                    {registrations.map(registration => (
                      <RegistrationItem
                        registration={registration}
                        key={registration._id}
                        onSubmit={this.handleSubmit}
                      />
                    ))}
                  </Col>}
              </Row>
            }}
          </Query>
        </div>
      </DashBoardBox>
    )
  }
}

const submitRegistrationMutation = gql`mutation submitRegistrationMutation ($_id: MongoID!) {
  submitRegistration(_id: $_id) {
    _id
    status
  }
}`

// code
// status
// userId
// eventId
// vipCode
// createdAt
// updatedAt
// _id
export default compose(
  graphql(submitRegistrationMutation, {
    name: 'submitRegistration'
  }),
  withApollo,
  inject('i18n'),
  observer
)(DashboardPage)



// WEBPACK FOOTER //
// ./src/App/DashboardPage/DashboardPage.js